import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Divider, FormInstance } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import GrantAccessToEmployeeButton from './GrantAccessToEmployeeButton';
import { Employee } from '@/core/domain/enterprise/Employees/Employees.types';

interface Props {
  disabled: boolean;
  form?: FormInstance;
  employee?: Employee | null;
}

const EmployeeFooter: React.FC<Props> = ({ disabled, form, employee }) => {
  const history = useHistory();

  return (
    <>
      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/registry/employees" disabled={disabled} />

        <Button
          block
          type="primary"
          onClick={() => {
            form?.resetFields();
            history.push('/app/registry/employees/create');
          }}
          disabled={!hasPermissions([Authorities.REGISTER_EMPLOYEE_ADD])}
        >
          Novo funcionário
        </Button>

        {hasPermissions([
          Authorities.ENABLE_EMPLOYEE_ACCESS_IN_YARD_MANAGEMENT,
        ]) &&
          !employee?.redirectKey && <GrantAccessToEmployeeButton />}
      </SpaceForButton>
    </>
  );
};

export default EmployeeFooter;
